import Cleave from 'cleave.js'

require('cleave.js/dist/addons/cleave-phone.br')

if ($('.phone').length) {
  new Cleave('.phone', {
    phone: true,
    phoneRegionCode: 'br'
  })
}

if ($('.mobile').length) {
  new Cleave('.mobile', {
    phone: true,
    phoneRegionCode: 'br'
  })
}

if ($('.date').length) {
  new Cleave('.date', {
    date: true,
    delimiter: '/',
    datePattern: ['d', 'm', 'Y']
  })
}

if ($('.initial_date').length) {
  new Cleave('.initial_date', {
    date: true,
    delimiter: '/',
    datePattern: ['d', 'm', 'Y']
  })
}

if ($('.final_date').length) {
  new Cleave('.final_date', {
    date: true,
    delimiter: '/',
    datePattern: ['d', 'm', 'Y']
  })
}

if ($('.zipcode').length) {
  new Cleave('.zipcode', {
    blocks: [5, 3],
    delimiter: '-',
    numericOnly: true,
  })
}